import { InputRef } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import editableContext from "./editable-context";
import StringRenderer from "./renderer/string-renderer";
import ReferenceRenderer from "./renderer/reference-renderer";
import DateRenderer from "./renderer/date-renderer";
import BooleanRenderer from "./renderer/boolean-renderer";

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  dataIndex: any;
  record: any;
  type: string,
  typeAttrs: any,
  handleSave: (record: any) => void;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  type,
  typeAttrs,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(editableContext)!;

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();

      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let Renderer;
  if(type === 'string') {
    Renderer = StringRenderer
  } else if(type === 'date') {
    Renderer = DateRenderer
  } else if(type === 'reference') {
    Renderer = ReferenceRenderer
  } else if(type === 'boolean') {
    Renderer = BooleanRenderer
  } else {
    Renderer = StringRenderer
  }

  return <td {...restProps}><Renderer editing={editing} editable={editable} inputRef={inputRef} dataIndex={dataIndex} save={save} toggleEdit={toggleEdit} {...typeAttrs} value={record && record[dataIndex]} record={record}>{ children }</Renderer></td>;
};

export default EditableCell;